export default () => ({
  isLoading: false,
  isReloading: false,
})
